export default {"src":"/_next/static/media/cards.7a1ae985.svg","height":69,"width":87,"blurWidth":0,"blurHeight":0};